import {
  ActionReducerMapBuilder,
  createAsyncThunk,
  PayloadAction,
} from '@reduxjs/toolkit'
import { AxiosRequestConfig, AxiosResponse } from 'axios'

import {
  WaterQualityIndexResponse,
  WaterQualityIndexState,
} from '../waterQualityIndex.types'
import { SippApi } from '../../../services/SippExpress'

interface FetchWaterQualityIndexParams {
  userId: string
  options?: AxiosRequestConfig
}

export const fetchWaterQualityIndexAsync = createAsyncThunk<
  WaterQualityIndexResponse,
  FetchWaterQualityIndexParams
>(
  'waterQualityIndex/fetch',
  async ({ userId, options = {} }, { rejectWithValue }) => {
    try {
      const response = (await SippApi.getWaterQualityIndex(
        userId,
        options
      )) as AxiosResponse<WaterQualityIndexResponse>
      return response.data
    } catch (error: any) {
      return rejectWithValue(
        error?.response?.data || {
          message: 'Unexpected error occurred',
          errors: [],
        }
      )
    }
  }
)

export const fetchWaterQualityIndexAsyncBuilder = (
  builder: ActionReducerMapBuilder<WaterQualityIndexState>
) => {
  builder.addCase(fetchWaterQualityIndexAsync.pending, (state) => {
    state.loading = true
    state.success = false
    state.error = null
  })
  builder.addCase(
    fetchWaterQualityIndexAsync.fulfilled,
    (state, action: PayloadAction<WaterQualityIndexResponse>) => {
      state.data = action.payload
      state.loading = false
      state.success = true
      state.error = null
    }
  )
  builder.addCase(
    fetchWaterQualityIndexAsync.rejected,
    (state, action: PayloadAction<any>) => {
      state.loading = false
      state.success = false
      state.error = action.payload
    }
  )
}
